import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import { isEmpty, uniq } from 'lodash';
import { isMobile } from 'react-device-detect';
import { ClaimJobPaymentItemAction, useClaimJobPaymentItemProvider } from '../Finance.ClaimJobPaymentItem.Hooks';

export default function ClaimJobPaymentItemActions() {
  const { lang } = getLocales();
  const { listApi, pageRouter, selectedItems, permissions, exportToExcel } = useClaimJobPaymentItemProvider();

  const disableCreatePayment =
    !permissions.CREATE_CLAIMJOBPAYMENT ||
    (selectedItems?.length > 0 &&
      (uniq(selectedItems.map((item) => item.claimJobItemPayee.typeAndId)).length > 1 ||
        uniq(selectedItems.map((item) => item.paymentMethodCode)).length > 1 ||
        uniq(selectedItems.map((item) => item.claimJob.claim.id)).length > 1));

  return (
    <>
      {selectedItems?.length ? (
        <>
          <Button
            class={ThemeButtonCircle}
            active
            media={<Icon class="fas-money-check-alt" />}
            render={lang.createPayment}
            onClick={pageRouter.updateParams}
            data={{ action: ClaimJobPaymentItemAction.CREATE_PAYMENT }}
            disabled={disableCreatePayment}
            htmlElementProps={{
              button: {
                title: disableCreatePayment && lang.unableToProcessPaymentItems,
              },
            }}
          />
        </>
      ) : null}
      <Button
        class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
        active
        media={<Icon class="fas-download" />}
        render={!isMobile && lang.export}
        onClick={exportToExcel}
        disabled={!permissions.CREATE_CLAIMJOBPAYMENT || isEmpty(listApi?.payload?.data)}
      />
    </>
  );
}
